<template>
  <benefit-dialog :visible="visible" :type="1" >
    <h2 class="benefit-title receive" slot="title">输入手机号码领取</h2>
    <form class="benefit-receive-form" slot="body">
      <h3 class="error-text" :style="{visible: errorMessage ? 1 : 0}">{{errorMessage}}</h3>
      <div class="input-container phone">
        <!-- <span class="label phone" :class="{show: showPhoneLabel || phoneNumber.length > 0}">手机号</span> -->
        <label class="label phone" for="phone-input" :class="{show: showPhoneLabel || phoneNumber.length > 0}">手机号</label>
        <input type="text" class="input" id="phone-input" v-model="phoneNumber"
          @input="errorMessage = ''" @focus="showPhoneLabel = true" @blur="showPhoneLabel = false"/>
        <a v-show="phoneNumber.length > 0" class="clear" href="javascript:;" @click="handleClearPhoneNumber"></a>
      </div>
      <div class="input-container">
        <label class="label verification-code" for="verification-input" :class="{show: showVerificationLabel || verificationCode.length > 0}">验证码</label>
        <input type="text" class="input"  id="verification-input" v-model="verificationCode" @input="errorMessage = ''"
          @focus="showVerificationLabel = true" @blur="showVerificationLabel = false"
        >
        <a class="verification" :class="{'pending': pending}" href="javascript:;" @click="handleGetVerification">
          <template v-if="!pending">获取验证码</template>
          <template v-else>重新获取&nbsp;{{curLimitTime}}</template>
        </a>
      </div>
    </form>
    <benefit-button slot="footer" @click.native="validateVerificationCode">立即领取</benefit-button>
  </benefit-dialog>
</template>

<script>
import BenefitButton from '@/components/benefit/button.vue'
import BenefitDialog from '@/components/benefit/dialog.vue'
import api from '@/components/api/benefit'
import { showShield } from '@/components/benefit/shields'
import eventHub from './eventHub'
import { stat } from './stat'
export default {
  components: {
    BenefitButton,
    BenefitDialog
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    from: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      phoneNumber: '',
      verificationCode: '',
      pending: false,
      maxLimitTime: 60,
      curLimitTime: 0,
      interval: null,
      showDialog: false,
      errorMessage: '',
      showPhoneLabel: false,
      showVerificationLabel: false
    }
  },
  methods: {
    handleClearPhoneNumber() {
      this.phoneNumber = ''
    },
    handleGetVerification() {
      if (!this.pending) {
        if (this.validatePhoneNumber()) {
          stat('event', 'page_click', { from: this.from, clickid: 'vericode' })
          eventHub.$emit('click:getVerificationCode')
          this.getVerification()
          this.pending = true
          this.startInterval()
        } else {
          this.errorMessage = '手机号码格式错误'
        }
      }
    },
    getVerification() {
      api
        .getCaptcha(this.phoneNumber)
        .then(data => {
          if (data.data.check === 'review') {
            showShield(data.data.data, '__benefit__')
          } else if (data.data.check === 'reject') {
            this.errorMessage = '您当前网络环境有异常'
          }
        })
        .catch(err => {})
    },
    validateVerificationCode() {
      if (!this.validatePhoneNumber()) {
        this.errorMessage = '手机号码格式错误'
        return
      }
      stat('event', 'page_click', { from: this.from, clickid: 'getnow' })
      api
        .codeValidate(this.phoneNumber, this.from, this.verificationCode)
        .then(data => {
          if (data.data.data && data.data.data.code === 0) {
            this.phoneNumber = ''
            this.verificationCode = ''
            const {
              benefitValue,
              benefit,
              isActive,
              validTime,
              telphone,
              isNewUser
            } = data.data.data.info
            if (isActive) {
              eventHub.$emit('update:props', 3, {
                benefitType: benefit,
                amount: benefitValue
              })
              eventHub.$emit('update:visible', 1, false)
              eventHub.$emit('update:visible', 3, true)
            } else {
              eventHub.$emit('update:props', 2, {
                benefitType: benefit,
                amount: benefitValue,
                phoneNumber: telphone,
                isNewUser,
                validTime
              })
              eventHub.$emit('update:visible', 1, false)
              eventHub.$emit('update:visible', 2, true)
            }
          } else {
            this.errorMessage = '验证码错误'
          }
        })
        .catch(err => {})
    },
    validatePhoneNumber() {
      return /^1[3456789]\d{9}$/.test(this.phoneNumber)
    },
    handleClearFrom() {
      this.handleClearPhoneNumber()
      this.verificationCode = ''
      this.errorMessage = ''
    },
    startInterval() {
      this.curLimitTime = this.maxLimitTime
      this.interval = window.setInterval(() => {
        if (this.curLimitTime === 1) {
          this.pending = false
          window.clearInterval(this.interval)
        }
        this.curLimitTime--
      }, 1000)
    }
  },
  mounted() {
    // 监听熊盾是否通过
    window.addEventListener('__benefit__', e => {
      if (e.detail.isSuccess === true) {
        api.getCaptcha(this.phoneNumber)
      } else {
        this.errorMessage = '您当前网络环境有异常'
      }
    })
  },
  created() {
    eventHub.$on('clearForm', this.handleClearFrom)
  },
  beforeDestroy() {
    window.clearInterval(this.interval)
    eventHub.$off('clearForm', this.handleClearFrom)
  }
}
</script>

<style lang=scss>
.benefit-receive-form {
  margin: 8.3px 0 40px 0; /*no*/
  .error-text {
    min-height: 17px; /*no*/
    font-size: 12px; /*no*/
    color: #fe4d40;
    text-align: center;
    margin-bottom: 46px; /*no*/
    font-weight: normal;
  }
  .input-container {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 20px; /*no*/
    .input {
      width: 100%;
      outline: none;
      border: none;
      border-bottom: 1px solid #e3e7eb; /*no*/
      font-size: 14px; /*no*/
      color: #26292d;
      line-height: 16px; /*no*/
      padding-bottom: 9px; /*no*/
      &::-webkit-input-placeholder {
        font-size: 14px; /*no*/
        color: #aaafb6;
        line-height: 16px; /*no*/
      } /* 使用webkit内核的浏览器 */
      &:-moz-placeholder {
        font-size: 14px; /*no*/
        color: #aaafb6;
        line-height: 16px; /*no*/
      } /* Firefox版本4-18 */
      &::-moz-placeholder {
        font-size: 14px; /*no*/
        color: #aaafb6;
        line-height: 16px; /*no*/
      } /* Firefox版本19+ */
      &:-ms-input-placeholder {
        font-size: 14px; /*no*/
        color: #aaafb6;
        line-height: 16px; /*no*/
      }
    }
    .label {
      display: block;
      margin-bottom: 7.333px; /*no*/
      font-size: 10px; /*no*/
      color: #949ba5;
      height: 17px; /*no*/
      &.error {
        color: #fe4d40;
      }
      &.phone,
      &.verification-code {
        /* opacity: 0; */
        position: absolute;
        bottom: 9px; /*no*/
        color: #aaafb6;
        font-size: 14px; /*no*/
        margin-bottom: 0;
        transition: 0.1s linear;
        transform: translateY(0); /*no*/

        &.show {
          color: #949ba5;
          transform: translate(-7px, -23px) scale(0.72); /*no*/
          /* opacity: 1; */
        }
      }
    }
    &:nth-child(2) {
      .clear {
        display: block;
        background-image: url('~assets/benefit/clear@3x.png');
        background-size: contain;
        position: absolute;
        right: 2.333px; /*no*/
        bottom: 12px; /*no*/
        width: 14px; /*no*/
        height: 14px; /*no*/
        border-radius: 50%;
      }
    }
    &:last-child {
      margin-top: 33px; /*no*/
      .verification {
        display: flex;
        position: absolute;
        bottom: 9px; /*no*/
        right: 0;
        justify-content: center;
        align-items: center;
        width: 84px; /*no*/
        height: 24px; /*no*/
        border: 1px solid #0050ff; /*no */
        border-radius: 20px; /*no*/
        font-size: 12px; /*no*/
        color: #0050ff;
        text-align: center;
        text-decoration: none;
        &.pending {
          border-color: #d5d9de;
          color: #d5d9de;
        }
      }
    }
  }
}
</style>
